import type { StepConfig } from "@portal/components/multiform/types";
import type { AdminCombinedFormData } from "../../schema";
import { BondTermsStep } from "./BondTermsStep";
import { BondTermsSummary } from "./BondTermsSummary";

export const bondTermsStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "bondTerms",
	label: "Bond Terms",
	fieldPaths: ["bondTerms"],
	component: BondTermsStep,
	summaryComponent: BondTermsSummary,
};
